export const regMap = new Map([
  ["password", /[^a-zA-Z0-9~!@#$%^&+=*(),.;:{}]/g],
  ["number", /^0+|[^\d]+/g]
]);
